import { SxProps, Theme } from '@mui/material';

/** Matches workflow drawer inner chrome (approval cards, stepper). */
export const ISSUE_VIEW_HEADER_HORIZONTAL_PAD_PX = 17;

export const issueViewHeaderSx: SxProps<Theme> = {
  display: 'flex',
  alignItems: 'center',
  gap: 1,
  minWidth: 0,
  width: '100%',
  flexShrink: 0,
  boxSizing: 'border-box',
  pl: `${ISSUE_VIEW_HEADER_HORIZONTAL_PAD_PX}px`,
  pr: `${ISSUE_VIEW_HEADER_HORIZONTAL_PAD_PX}px`,
  py: 2,
  borderBottom: 1,
  borderColor: 'divider',
  backgroundColor: 'background.paper',
};

/**
 * Fixed width for the [process tile + NCR number] group so the next/prev chevrons
 * keep a constant span and don't jump when switching between issues with shorter
 * codes. The group is centered, so the tile stays right next to the number while
 * the empty space is split evenly on both sides. Sized to fit the longest
 * realistic code (e.g. `2025/ENV/KTULA/de9f`, 19 chars) plus the process pill and
 * gap; the buffer accounts for the non-monospace font where uppercase letters are
 * wider than the `ch` unit.
 */
export const ISSUE_CODE_NAV_GROUP_WIDTH = 'calc(21ch + 2.75rem)';

export const issueNavigationClusterSx: SxProps<Theme> = {
  display: 'inline-flex',
  alignItems: 'center',
  flexShrink: 0,
  gap: { xs: 0, sm: 0.25 },
};

export const issueCodeNavGroupSx: SxProps<Theme> = {
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  gap: 0.75,
  flexShrink: 0,
  overflow: 'hidden',
  width: ISSUE_CODE_NAV_GROUP_WIDTH,
  minWidth: 0,
};

export const issueCodeNavTypographySx: SxProps<Theme> = {
  fontWeight: 600,
  whiteSpace: 'nowrap',
  overflow: 'hidden',
  textOverflow: 'ellipsis',
  lineHeight: 1.25,
  margin: 0,
  padding: 0,
  flexShrink: 1,
  minWidth: 0,
  fontSize: { xs: '0.8125rem', sm: '0.875rem', md: '0.9375rem' },
};
